const swiper = new Swiper("#swiper-teacher-es", {
	// slidesPerView: 3,
    // centeredSlides: true,
	// loop: true,
	spaceBetween: 16,
	loop: true,
	slidesPerView: 1.6,
    slidesOffsetBefore: 15,
	navigation: {
		nextEl: ".custom-swiper-button-next",
		prevEl: ".custom-swiper-button-prev",
	},

	pagination: {
		clickable: true,
		el: ".custom-swiper-pagination",
	},

	breakpoints: {
		560: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 2.65,
		},
		1024: {
            slidesPerView: 3.75,
		},
		1140: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
		},
		1320: {
            slidesPerView: 4,
		},
	},
});


/*
const swiper = new Swiper("#swiper-teacher-es", {
	// slidesPerView: 3,
	// spaceBetween: 16,
	// loop: true,
	loop: true,
	slidesPerView: 1.5,

	navigation: {
		nextEl: ".custom-swiper-button-next",
		prevEl: ".custom-swiper-button-prev",
	},

	pagination: {
		clickable: true,
		el: ".custom-swiper-pagination",
	},

	breakpoints: {
		768: {
			slidesPerView: 3.5,
			centeredSlides: true,
			rewind: true,
		},
		1024: {
		},
		1200: {
		},
		1320: {
		},
	},
});
*/